import styled from 'styled-components';
import { COLORS } from '@/theme';

export const CanvasCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CanvasPageFrame = styled.div`
  margin-top: 4px;
  padding: 8px;
  border-radius: 8px;
  background: ${COLORS.GRAY};
  border: 1px dashed ${COLORS.SOFT_GRAY};
`;
